<!--
 Copyright (c) Qwoach LLC 2020. All rights reserved.
 Unauthorized copying of this file, via any medium is strictly prohibited
 Proprietary and confidential
 Created by Artem Bogush <artem@qwoach.com> on 8/25/20
-->

<template>
	<FormElementTemplate
		class="multiple-element-root"
		:formElement="formElement"
		:viewMode="viewMode"
		v-bind="$attrs"
	>


		<template #body>
			<slot name="body">

				<div v-if="isEditMode">
					<slot name="contentEditMode">

						<FormRow :showDivider="false">
							<div class="row mx-0 hide-on-print" v-if="formElement.isScoringEnabled()">
								<div class="layout-spacer"/>
								<div class="bold mr-2">
									Score
									<ToolTipView>
										This is the scores assigned to each answer.
										<br/><br/>
										You can use numbers and operators +, -, *, /, ^, parentheses, and #ans (to refer to the number of answers given) to assign the score.
										<br/><br/>
										Score allows you to keep track of your client's progress over time based on
										their
										responses.
										<br/><br/>
										Your client won't see the score assigned to each answer, only the final result.
									</ToolTipView>

								</div>

							</div>


							<div v-for="(option, index) in formElement.answerOptions" :key="index"
								 class="show-on-hover-parent2">
								<div class="row mx-0 my-2 align-items-center">
									<div>
										<slot name="elementEditMode"/>
									</div>
									<div class="padding-left col">
										<qw-input v-model="formElement.answerOptions[index]"
												  :readonly="!isSelected || !isEditable || !isEditMode"
												  placeholder="Type option here"
												  :showDivider="isSelected"
												  :showDividerOnHover="isSelected"
												  @input="inputChangedDebounced"
												  @focus="onFocusChanged(index, true)"
												  @blur="() => {onFocusChanged(index, false); inputChanged()}"/>
										<!--								<div v-if="isSelected">-->
										<!--									<hr v-if="focusedOptions[index]" class="border-primary"/>-->
										<!--									<hr v-else class="show-on-hover-item2"/>-->
										<!--								</div>-->
									</div>
									<div v-if="!isAnswerMode && formElement.isScoringEnabled()" class="hide-on-print">
										<qw-input
											:readonly="!isSelected || !isEditable || !isEditMode"
											style="width: 90px;"
											v-model="formElement.answerOptionsScoring[index]"
											class="text-center"
											:input-debounce-delay="inputDebounceDelay"
											@input="notifyElementChanged"
											@blur="validateScoreFormula(index)"
											@change="onScoreChangedManually"/>
										<!--										<qw-select v-if="hasBucketScoreResult" :options="[{label:'hey', value:'id1'}, {label:'there', value:'id2'}]"/>-->
									</div>

									<div v-if="isSelected" class="hide-on-print">
										<i class="fontello icon-trash button-circle" @click="deleteOption(index)"/>
									</div>
								</div>
							</div>
						</FormRow>
						<div class="show-on-hover-parent2 dotted form-padding" v-if="formElement.showOtherOption">
							<div class="row mx-0 mt-2 align-items-center item-height">
								<div class="col px-0" @click.prevent>
									<div class="row mx-0 align-items-center">
										<slot name="elementEditMode"/>
										<span class="text-muted padding-left"><span :class="{'pl-3': !isSelected}">Other... (client will be asked to type their response)</span></span>
									</div>
								</div>
								<div v-if="isSelected" class="mr-1">
									<i class="fontello icon-trash button-circle hide-on-print"
									   @click="deleteOtherOption()"/>
								</div>
							</div>
							<div class="ml-4">
								<hr v-if="isSelected" class="show-on-hover-item2"/>
							</div>
						</div>
						<div v-if="isSelected"
							 class="row mx-0 my-3 form-padding align-items-center item-height hide-on-print">
							<div>
								<slot name="elementEditMode"/>
							</div>
							<div style="padding-left: 10px;">
								<div
									class="display-inline-block pointer text-muted input-background input-height px-3 input-height"
									@click="addOption"><span class="border-bottom-hover">Add option</span></div>
								<span
									v-if="canShowOtherButton && !formElement.showOtherOption"> or <a href="#"
																									 class="pointer"
																									 @click.prevent="addOther">add "Other"</a></span>
							</div>
						</div>
					</slot>

				</div>


				<div v-else>
					<slot name="viewList" :formElement="formElement"/>
				</div>
			</slot>
		</template>

		<template #menuOptionsLeft>
			<div>
				<div v-if="formElement.showScoring" class="qw-row">
					<qw-checkbox v-model="formElement.enableScoring" @change="notifyElementChanged">
						Enable Scoring
					</qw-checkbox>
<!--					<ToolTipView v-if="formElement.enableScoring" position="bottom">-->
<!--						<template #icon><i class="fontello ml-2 cursor-pointer" :class="iconScoringDirection"-->
<!--										   @click="switchScoringDirection"/></template>-->
<!--						Auto scoring {{ formElement.autoScoreDirectionText() }}-->
<!--						<br/><br/>-->
<!--						Click to toggle-->
<!--					</ToolTipView>-->
					<ToolTipView position="bottom">
						Scoring allows you to keep track of client's progress over time by assigning a numerical value
						to each answer.
						<br/><br/>
						As client answers the same form over time, it can be used to further visualize their progress.
					</ToolTipView>
				</div>

				<slot name="menuOptionsLeft"></slot>

			</div>

		</template>

	</FormElementTemplate>
</template>

<script>

import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";
import BaseFormElementView from "@/core/modules/coach/Resources/Forms/FormElements/BaseFormElementView.vue";
import FormElementTemplate from "@/core/modules/coach/Resources/Forms/FormElements/FormElementTemplate.vue";
import FormRow from "@/core/components/Form/Base/FormRow.vue";
import {deleteConfirmDialog, messageDialog} from "@/core/components/Dialogs/dialog";
import BaseMultiFormElement from "@/core/modules/coach/Resources/Forms/model/FormElements/General/BaseMultiFormElement";
import QwInput from "@/core/components/Controls/QwInput.vue";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
import BaseFormElement from "@/core/modules/coach/Resources/Forms/model/FormElements/BaseFormElement";

export default {
	name: "FormMultipleView",
	components: {ToolTipView, QwInput, FormRow, FormElementTemplate},
	extends: BaseFormElementView,
	props: {
		formElement: [BaseMultiFormElement, BaseFormElement],
		canShowOtherButton: {type: Boolean, default: true}
	},

	data() {
		return {
			focusedOptions: {},
		}
	},

	created() {

	},

	methods: {


		onFocusChanged(index, isFocused) {
			// this.$set(this.focusedOptions, index, isFocused)
			this.focusedOptions[index] = isFocused
		},

		addOption() {
			this.formElement.answerOptions.push("")
			this.notifyAnswerOptionsChanged()
			this.notifyElementChanged()
		},
		addOther() {
			this.formElement.showOtherOption = true
			this.notifyAnswerOptionsChanged()
			this.notifyElementChanged()
		},

		async deleteOption(index) {
			let shouldDelete = await deleteConfirmDialog({itemName: "option"})
			if (shouldDelete) {
				this.formElement.answerOptions.splice(index, 1)
				this.notifyAnswerOptionsChanged()
				this.notifyElementChanged()
			}
		},

		async deleteOtherOption() {
			let shouldDelete = await deleteConfirmDialog({itemName: "option"})
			if (shouldDelete) {
				this.formElement.showOtherOption = false
				this.notifyAnswerOptionsChanged()
				this.notifyElementChanged()
			}
		},

		notifyAnswerOptionsChanged() {
			if (!this.formElement.isScoringManual) {
				this.recalculateScoring()
			}
		},

		onScoreChangedManually() {
			this.formElement.isScoringManual = true
			// if(!this.formElement.isScoringManual){
			// 	this.formElement.isScoringManual = true
			// 	this.notifyElementChanged()
			// }
		},

		async validateScoreFormula(index){
			let score = this.formElement.answerOptionsScoring[index]
			score = score || "0"
			score = score.trim()
			this.formElement.answerOptionsScoring[index] = score

			let res = this.parseExpression(score)
			if(!res){
				await messageDialog({
					title: "Invalid score formula",
					message: `Please doublecheck your score formula. Only numbers, operators (+, -, *, /, ^), parentheses, and #ans are allowed.<br/><br/>Invalid formula for:<br/>'${this.formElement.title || '(no title)'}'<br/>&emsp;${this.formElement.answerOptions[index] || '(no option)'}: <b>${score}</b>`,
				})
			}

		},

		parseExpression(expression) {
			const allowedRegex = /^[0-9+\-*/^()%#ans\s]+$/;
			if (!allowedRegex.test(expression)) {
				return false
			}

			try {
				expression = expression.replaceAll("#ans", "1")
				let res = eval(expression);
				console.log("res = ", res)
				return true
			} catch (error) {
				console.error("Error in parsing expression:", error);
				return false
			}
		},


	},

	computed: {
		answerPlaceholder() {
			if (this.isViewMode) {
				return "Your answer"
			}
			switch (this.formElement.type) {
				case FormElementType.MULTILINE:
					return "Long answer text"
			}
			return "Short answer text"
		},

		bucketScoreResultItems() {
			let items = []
			this.formItem.formElements.forEach(formElement => {
				if (formElement.type === FormElementType.SCORE_RESULT) {
					items.push(formElement)
				}
			})
			return items
		},

		hasBucketScoreResult() {
			return this.bucketScoreResultItems.length > 0
		},

	}

}
</script>

<style lang="scss">

.multiple-element-root {
	.padding-left {
		padding-left: 10px
	}

	.el-form-item__content {
		//line-height: 20px !important;
	}

	.item-height {
		height: 30px;
		line-height: 1px !important;


		.el-input, {
			line-height: 30px;
		}

		.el-input__inner {
			height: 30px !important;
		}
	}

	.item-height {
		height: auto;
		line-height: 30px;
		padding-bottom: 15px;

		//height: px-to-rem(40);
		//line-height: px-to-rem(40);


		//.el-input,{
		//	line-height: 30px;
		//}
		//.el-input__inner{
		//	height: 30px !important;
		//}
	}

	.item-height.answer {
		height: auto;
		line-height: 30px;
		padding-bottom: 15px;
		//height: 30px;
		//line-height: 30px;


		//.el-input,{
		//	line-height: 30px;
		//}
		//.el-input__inner{
		//	height: 30px !important;
		//}
	}

}

</style>
